export const COMPANIES = {
    TEST: 'teambluetest',
    SUPPORT: 'supportomuni',
    PRODUCTION: 'omuni',
    ECUADOR: 'stctea',
    MUNDO_CREDITO: 'mundocredito',
    LINZE: 'linze',
    LINZE_LEADS: 'linzeleads',
    LINZE_TEST: 'linzetest',
    EPEC: 'epec',
    DENWAIP: 'denwaip',
    FACEBOOK_TEST: 'facebooktest',
    GLOBAL_THINK_TEC: 'globalthinktec',
    DEMO_OMUNICEM: 'demoomunicem',
    PROMEDON: 'PROMEDON',
    IH: 'ih',
    PRUEBA_IH_8: 'pruebaih8',
    DEBORA: 'debora',
    MAVIGPS: 'mavigps',
    VIAJA_YA: 'viajaya',
    TEAM_ORANGES_STAKEHOLDERS: 'teamorangestakeholders',
    VIAJA_YA_TEST: 'viajayatest',
    NACHOSA: 'nachosa',
    TEAM_YELLOW_STAKEHOLDERS: 'teamyellowstakeholders',
    NUEVA_COMPANY_21_03: 'nuevacompany21/03',
    NUEVA_COMPANY_21_03_ALT: 'nuevacompany21-03',
    LUCARDOSA: 'lucardosa',
    LA_PIAMONTESA: 'lapiamontesas.a.',
    LUCAS_INC: 'lucasinc',
    SERVICIO_AGUA: 'serviciodeaguaymantenimientoempresadelestadoprovincial(sammep)',
    AUTOPISTA_INFO_SAN_LUIS_1: 'autopistadelainformación-sanluis',
    AUTOPISTA_INFO_SAN_LUIS_2: 'autopistadelainformacion-sanluis',
    ATER: 'ater',
    TEAM_BLUE_TEST: 'teambluetest',
    LINZE_2: 'linze',
    TEST_2: 'test',
    OBRAS_SANITARIAS_SEMGP: 'obrassanitariassemgp',
    MESSISISMO: 'messisismo',
    LEOS_CORPORATION: 'leoscorporation',
    AIR_SRL_ADVANTEC: 'airsrladavantec',
    AQUA_OCCIDENTE_SA_ESP: 'aquaoccidentesaesp',
    OMUNION_BOARDING: 'omunionboarding',
    CHECKER: 'checker',
    CHILE_TICKETS: 'chiletickets',
    OSA: 'osa',
    SARAVIANDO: 'saraviando',
    SARAVIANDO_DEMO: 'saraviandodemo',
    SAINT_GERMAIN: 'saintgermain',
    SIAV: 'siav',
    BIKLETA: 'bikleta',
    RAPISUR: 'rapisur',
    OMUNI: 'omuni',
    GLOBAL_LINZE_STAKEHOLDERS: 'globallinzestakeholders',
    GLOBAL_MAVIS_STAKEHOLDERS: 'globalmavistakeholders',
    GLOBAL_OMUNIS_STAKEHOLDERS: 'globalomunistakeholders',
    GLOBAL_CHILE_TICKETS_STAKEHOLDERS: 'globalchiletiketsstakeholders',
    GLOBAL_BIKLETA_STAKEHOLDERS: 'globalbikletastakeholders',
    FITNESS: 'Fitness',
    CMAD: 'cmad',
    ONE_HUNDRED: '100',
    SERCOM: 'sercom',
    TEAM_BLACK_GLOBAL_THINK: 'teamblackglobalthink',
    PEPITO_PISTOLAS: 'pepitopistolas',
    PINK_CHAIR: 'pinkchair',
    AGENCIA_MERKEN: 'Agencia Merken',
    MAVI_MOVIL_SPA: 'Mavimovil Spa',
    INMOBILIARIA_CERCATROVA: 'inmobiliariacercatrova',
    CLUB_ATLETICO_LAS_PALMAS: 'clubatleticolaspalmas',
    ARZ_SPORT: 'arzsport',
    TERCERA_GENERACION: '3RA GENERACION',
    BUSINESS_SOLUTIONS_AND_SERVICES: 'Business Solutions and Services',
    LIMPIO_SRL: 'limpiosrl',
    APURO_TIENDA: 'apurotienda',
    LINZE_LEADS: 'linzeleads'
};
